import { render } from "./TeamTreeBranch.vue?vue&type=template&id=07e6bfe6&scoped=true"
import script from "./TeamTreeBranch.vue?vue&type=script&lang=js"
export * from "./TeamTreeBranch.vue?vue&type=script&lang=js"

import "./TeamTreeBranch.vue?vue&type=style&index=0&id=07e6bfe6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e6bfe6"]])

export default __exports__